import { GuideItem } from '../GuideItem';
import * as style from './GuideList.css';
import { useDeviceType } from '@cian/ui-kit';
import classnames from 'classnames';
import { TGuideList } from 'shared/types/giude';
import { EWantTypeId } from 'shared/types/wantType';

interface IGuideList {
  list: TGuideList[];
  activeType: EWantTypeId;
}

export const GuideList: React.FC<IGuideList> = ({ list, activeType }) => {
  const device = useDeviceType();

  return (
    <div
      key={activeType}
      className={classnames(
        style['container'],
        style['swing-in-top-fwd'],
        device === 'phone' && style['container-phone'],
      )}
    >
      {list.map(item => (
        <GuideItem key={item.step} {...item} />
      ))}
    </div>
  );
};
